import useUserStore from "../../../storeModules/useUserStore";
import useBotControlStore from "../../../storeModules/useBotControlStore";
import findStep from "./findStep";
import { resetStoreComprarNovaCota } from "../../../storeModules/resetStoreComprarNovaCota";
import useInitialConfigStore from "../../../storeModules/useInitialConfigStore";
import sendTag from "../../../utils/sendTag";

const errorSteps = [
  {
    name: "error-no-plans",
    isWaitingForFetch: true,
    sender: "bot",
    text: () => {
      const userBasicName = useUserStore.getState().basic.nome;
      return `<b>${userBasicName}, não encontrei nenhum plano com este valor.</b> Por favor, faça uma nova simulação.`;
    },
    options: [
      {
        text: "SIMULAR NOVAMENTE",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("lead-credit-value").index,
          });
        },
      },
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(linkWhatsApp, "_blank");
        },
      },
    ],
  },
  {
    name: "error-renda-insuficiente",
    isWaitingForFetch: true,
    sender: "bot",
    text: () => "Você tem alguma renda extra ou familiar?",
    options: [
      {
        text: "NÃO TENHO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("sem-renda-extra").index,
          });
        },
      },
      {
        text: "TENHO",
        action: () => {
          useBotControlStore.setState({
            currentStep: findStep("com-renda-extra").index,
          });
        },
      },
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(linkWhatsApp, "_blank");
        },
      },
    ],
  },
  {
    name: "error-general",
    isWaitingForFetch: true,
    sender: "bot",
    text: "Desculpe, estamos passando por instabilidades. Tente novamente mais tarde.",
    options: [
      {
        text: "TENTAR NOVAMENTE",
        action: () => {
          resetStoreComprarNovaCota();

          useBotControlStore.setState({
            currentStep: findStep("copy-message-2").index,
          });
        },
      },
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          const linkWhatsApp = useInitialConfigStore.getState().linkWhatsApp;
          window.open(linkWhatsApp, "_blank");
        },
      },
    ],
  },
  {
    name: "sem-metodos-pagamento",
    sender: "bot",
    text: "Para seguir com a escolha da forma de pagamento da primeira parcela e efetivar a contratação da sua cota, clique no botão abaixo para confirmar o seu cadastro com um de nossos especialistas.",
    options: [
      {
        text: "FALAR COM OS ESPECIALISTAS",
        action: () => {
          window.open(
            "https://api.whatsapp.com/send?1=pt_BR&phone=551131926065",
            "_blank"
          );

          sendTag({
            event: "WhatsApp Sem Métodos de Pagamento",
          });
        },
      },
    ],
  },
];

export default errorSteps;
